import { useUserStore } from '@/store/user';
import { supabase } from '@/utils/supabase';
import { GoogleSignin } from '@react-native-google-signin/google-signin';
import { router } from 'expo-router';
import { default as React } from 'react';
import { Alert, Text, View } from 'react-native';
import GoogleButton from '../../components/GoogleButton';
import '../../global.css';

const handleGoogleSignInButtonClick = async () => {
  try {
    await GoogleSignin.hasPlayServices({ showPlayServicesUpdateDialog: true });
    GoogleSignin.configure({
      webClientId: '978887347421-mue03lgm1p8tsur30br963vi547nnrsp.apps.googleusercontent.com',
    });

    const wha = await GoogleSignin.signIn();
    console.log(wha);

    if (wha.data.idToken) {
      const { data, error } = await supabase.auth.signInWithIdToken({
        provider: 'google',
        token: wha.data.idToken,
      });

      console.log(data);
      console.log(error);

      const user = {
        id: data.user.id,
        email: data.user.email || '',
        fullName: data.user.name || '',
        isSubscribed: false,
        profileImage: data.user.photo || '',
      };
      console.log('Logged in:', user);
      useUserStore.getState().setUser(user);

      if (user) {
        console.log('User signed in successfully', user);
        router.replace('/(root)/(tabs)/Places');
      }
    }
  } catch (error: any) {
    console.log('Error signing in', error.message);
    Alert.alert('Error', error.message);
  } finally {
  }
};

//Login logic goes here
const LoginScreen = () => {
  return (
    <View className="flex-1 bg-white p-6">
      {/* Logo and Title */}
      <View className="items-center mt-24 gap-4">
        <Text className="text-3xl font-bold text-center">Buskin</Text>
      </View>
      {/* Google Login */}
      <View className="items-center mb-6">
        <GoogleButton onPress={handleGoogleSignInButtonClick} />
      </View>
    </View>
  );
};

export default LoginScreen;
